module.exports = __webpack_public_path__ + "img/vlag-en.0f2a7bd8699d4ceea596dba2204b75d7.svg";